import styled, { css } from 'styled-components';

export const Container = styled.section``;

export const Text = styled.p`
  font-weight: 400;
  font-size: 2rem;
  line-height: 3.6rem;
  margin: 0;

  strong {
    font-weight: 700;
  }
`;

export const CheckAppText = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.primary100};
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2.4rem;
  `}
`;

export const Button = styled.button`
  margin: 4px 0 0 0;
  padding: 4px 0;

  background: transparent;
  border: 0;

  cursor: pointer;
`;

export const VerifyLink = styled.a`
  ${({ theme }) => css`
    display: inline-block;
    margin: 2.4rem 0 0 0;
    padding: 1.2rem 2.4rem;

    background: ${theme.colors.primary100};
    border-radius: 0.8rem;

    color: #fff;
    font-weight: 700;
    font-size: 1.6rem;
    text-decoration: none;
  `}
`;
